import { formatPrice } from 'ha/utils/formatPrice';

export const priceRange = (
  currency: string,
  minPrice?: number | null,
  maxPrice?: number | null,
): string =>
  [minPrice, maxPrice]
    .filter(price => price !== undefined && price !== null)
    .map(price => formatPrice(price as number, currency))
    .join(' - ');
